import {
    postFilesClientLoading,
    postFilesClientRequest,
    postFilesClientSuccess,
    postFilesClientReject,
    postFilesClientReset
} from "../../actions/filesClient/post";

export const postFilesClient = (formData) => async (dispatch, getState) => {
    dispatch(postFilesClientLoading());
    try {
        const { data } = await postFilesClientRequest(formData, getState);
        dispatch(postFilesClientSuccess(data))
    } catch (error) {
        dispatch(postFilesClientReject(error))
    } finally {
        setTimeout(() => { dispatch(postFilesClientReset()) }, 3000);
    }
    return Promise.resolve();
};
